import React, { useState } from 'react'
import { Backdrop, Box, Button, IconButton, Link, styled, Typography, useTheme } from '@mui/material'
import MicIcon from '@mui/icons-material/Mic';
import MicOffIcon from '@mui/icons-material/MicOff';
import { socket } from '../../../config/SocketApi'
import MailLockIcon from '@mui/icons-material/MailLock';
import BackHandIcon from '@mui/icons-material/BackHand';
import { useAuthContext } from '../../auth/hooks/useAuthContext';
import Avatar from '@mui/material/Avatar';
import { buildBackendUrl } from '../../../config/API';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { getInitialForAvatar } from '../helpers/helperMethods/getInitials';
import { DESKTOP_APP_DOWNLOAD_URL } from '../../../config/staticUrls';
import StudentScreenShareControl from './StudentScreenShareControl';

// Modern styled components
const AttendeeBox = styled(Box)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '10px 16px',
    width: '100%',
    borderRadius: '8px',
    background: 'rgba(255, 255, 255, 0.02)',
    transition: 'all 0.2s ease',
    '&:hover': {
        background: 'rgba(255, 255, 255, 0.05)',
    },
}))
const AttendeeInfo = styled(Box)({
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    gap: '12px'
})

const AttendeeStatusBox = styled(Box)(({ isOnline }) => ({
    width: '8px',
    height: '8px',
    borderRadius: '50%',
    backgroundColor: isOnline ? '#22c55e' : '#6b7280',
    boxShadow: isOnline ? '0 0 8px rgba(34, 197, 94, 0.5)' : 'none',
}))
const AttendeeControlls = styled(Box)({
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'center',
    gap: '4px'
})

const Attendee = ({ data, onaddPrivateMessage, room_id, allowStudentScreenShare = true }) => {
    console.log("the room id ", room_id)
    const theme = useTheme();
    const { user } = useAuthContext() || JSON.parse(localStorage.getItem("user"));
    const { meetingStarted } = useSelector((store) => store.meeting)
    const [downloadApp, setDownloadApp] = useState(false)
    const { t } = useTranslation();
    const [micSent, setMicSent] = useState(false)
    const AskedForMicWrapper = styled(Box)({
        display: 'flex',
        flexDirection: 'column',
        border: `1px solid ${theme.palette.text.secondary}`,
        margin: 'auto',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: theme.palette.background.default,
        padding: 20
    })
    const ButtonsRow = styled(Box)({
        display: 'flex',
        flexDirection: 'row',
        width: '100%',
        margin: 'auto',
        justifyContent: 'flex-start',
        alignItems: 'center',
        marginTop: 20,
        backgroundColor: theme.palette.background.default,
        gap: 20
    })
    const handleOpenCloseStudentMic = () => {
        if (data?.micConnected) {
            socket.emit("close-student-mic", data.user_id)
        } else {
            socket.emit("open-student-mic", data.user_id);
            setMicSent(true);
        }
    }
    return (
        <AttendeeBox>
            <Backdrop
                sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={downloadApp}
            >
                <AskedForMicWrapper>
                    <Typography variant='h4'>{t('downloadAppMessage')}</Typography>
                    <ButtonsRow>
                        <Link target="_blank" rel="noopener noreferrer" href={DESKTOP_APP_DOWNLOAD_URL}><Button onClick={()=>setDownloadApp(false)}  variant="contained" >{t("downloadApp")}</Button></Link>
                        <Button onClick={() => {  setDownloadApp(false) }} variant="contained" sx={{ backgroundColor: theme.palette.danger.main }}>{t("close")}</Button>
                    </ButtonsRow>
                </AskedForMicWrapper>

            </Backdrop>
            <AttendeeInfo>
                <AttendeeStatusBox ></AttendeeStatusBox>
                <Avatar  alt={data.user_name} src={buildBackendUrl(data?.user_image)} >{getInitialForAvatar(data.user_name)}</Avatar>
                <Typography sx={{ color: data?.user_type !== 0 ? theme.palette.secondary.main : theme.palette.text.default }}>{data?.user_name}</Typography>
                {data?.handRaised && <BackHandIcon data-testid="attendee-raised-hand" color="warning" fontSize="small" />}
                {allowStudentScreenShare && user && user.user_type === 0 && data.user_id === user.id && !meetingStarted && (
                    <StudentScreenShareControl roomId={room_id} direction={theme.direction} />
                )}
            </AttendeeInfo>
            <AttendeeControlls>
                {user && user.user_type !== 0 && data.user_id !== user.id && !meetingStarted && <IconButton aria-label={data?.micConnected ? 'Mute student' : 'Request student microphone'} disabled={micSent} onClick={() => handleOpenCloseStudentMic()}>{data?.micConnected ? <MicOffIcon sx={{ color: theme.palette.secondary.main }} /> : <MicIcon sx={{ color: micSent ? theme.palette.background.gray : theme.palette.secondary.main }} />}</IconButton>}
                {user && data.user_id !== user.id && <IconButton aria-label={`Private message ${data?.user_name}`} onClick={() => onaddPrivateMessage(data.user_id, data?.user_name)}>
                    <MailLockIcon sx={{ color: theme.palette.secondary.main }} /></IconButton>}
            </AttendeeControlls>
            {/* <video ref={videoRef} autoPlay style={{ width: '100%', height: 'auto' }} /> */}
        </AttendeeBox>

    )
}

export default Attendee
